import React from 'react';
import { FiXCircle, FiCheckCircle } from "react-icons/fi"
import Status from './Status'
import Price from './Price'
const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
]


export default function ItemWStat (props) {

    const {item,link,onAccept,onDecline,onDelete,onCancel,extraContent,setAlert,F,navigation,event,styleDirection} = props
    return(
        <React.Fragment>
            {console.log('styleDirection', styleDirection)}
            <div style={{flexDirection:  styleDirection  === 'inline'  ? 'row' : 'column', alignItems: 'center', display: 'flex'}}>
                <Status status={item.status}/>
                <div style={{display:'flex', flexDirection: 'row'}}>
                    <div style={{flexDirection:'row',alignItems:'center', display: 'flex', }}>
                        <div onClick={link}>
                            <p className='listText'
                            // numberOfLines={1}
                            style={{color:'white',fontSize:14, marginInlineEnd: 0 }}>
                                {item.venueName || item.type} 
                                {item.date && `|  ${months[item.date.getMonth()]} ${item.date.getDate()}`}
                                </p>
                        </div>
                        {item.price && item.status == "Booked" &&
                        <Price price={item.price} type="pay" item={item} F={F} navigation={navigation} event={event}/>}
                    </div>
                    <div style={{flexDirection:'row',justifyContent:"space-between", display:  'flex'}}>
                        {item.status == 'Requested' && onAccept && 
                        <button className='BrowseButton'
                            style={{display: 'flex', flexDirection: 'row'}}
                            key={item.bookingId+'acBtn'}
                            onClick={onAccept}>
                                Accept
                                <FiCheckCircle style={{marginInline: 5}}/>
                            </button>}
                        {
                            <button
                            className='BrowseButton'
                            style={{borderWidth: 0, paddingBlock: 5, paddingInline: 10, color: 'var(--red)',}}
                            key={item.bookingId+'DBtn'} 
                            onClick={()=>{
                                setAlert({
                                comment:item.status == 'Requested' ? 'Decline Request' : item.status === 'Canceled' ? 'Delete Event' : 'Cancel Booking',
                                options:[
                                    {text: "No", style:"cancel"},
                                    {text: `${item.status == 'Requested'?'Decline':item.status == 'Canceled' || (item.status == 'Expired')?'Delete':'Cancel'}`, 
                                    onClick: item.status == 'Canceled' || (item.status == 'Expired') ? 
                                    onDelete
                                    :
                                    (onDecline || onCancel), 
                                    style: "destructive"}
                                ]                   
                            })
                            }}>
                                {item.status == 'Requested' && onDecline &&'Decline'}<FiXCircle style={{fontSize: 16, marginInline: 5, color: 'var(--red)'}}/>
                            </button>}
                    </div>
                </div>
            </div>
            {extraContent}
            {/* {styleDirection !== 'inline' && <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />} */}
        </React.Fragment>
    )
}